const getDomElmOnAttr = ({ attrName, attrValue }) => {
	return document.querySelector(`[${attrName}='${attrValue}']`);
};

const getNextDomElmOnAttr = ({ attrName, attrValue }) => {
	const curElm = getDomElmOnAttr({ attrName, attrValue });
	if (curElm) {
		return curElm.nextElementSibling;
	}
};

const getPrevDomElmOnAttr = ({ attrName, attrValue }) => {
	const curElm = getDomElmOnAttr({ attrName, attrValue });
	if (curElm) {
		return curElm.previousElementSibling;
	}
};

const getNextDomAttrOnAttr = ({ attrName, attrValue }) => {
	const nextElm = getNextDomElmOnAttr({ attrName, attrValue });
	return nextElm?.attributes?.[attrName]?.value;
};

const getPrevDomAttrOnAttr = ({ attrName, attrValue }) => {
	const prevElm = getPrevDomElmOnAttr({ attrName, attrValue });
	return prevElm?.attributes?.[attrName]?.value;
};

/**
 * Возвращает числовое значение CSS свойства элемента
 * или ноль, если оно нечисловое
 * @param {HTMLElement} elem - элемент
 * @param {string} property - название свойства
 * @param {string} unit - название единицы измерения
 * @returns {number}
 */
export const getCssNumberValue = (elem, property, unit) => {
	const value = parseFloat(
		getComputedStyle(elem, null)
			.getPropertyValue(property)
			.replace(`${unit ?? "px"}`, "")
	);

	return Number.isNaN(value) ? 0 : value;
};

export { getNextDomAttrOnAttr, getPrevDomAttrOnAttr };

export const getElementByXpath = ({ xpath }) => {
	try {
		return document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
	} catch {
		return null;
	}
};
